import { Module } from "wrapper6";

var $ = jQuery;

export default class SocialShare extends Module {

	ready(app) {

        const SOCIAL_ICONS = document.querySelectorAll('.social-share-icon');
        this.NETWORKS = {
            facebook: { width: 600, height: 300 },
            twitter: { width: 600, height: 254 },
            linkedin: { width: 600, height: 473 }
        };

        if (SOCIAL_ICONS.length) {
            for (let i = 0; i < SOCIAL_ICONS.length; i++) {
                
                const SOCIAL_ICON = SOCIAL_ICONS[i];

                SOCIAL_ICON.addEventListener('click', (e) => {
                    e.preventDefault();
                    let href = SOCIAL_ICON.getAttribute('href');
                    let network = SOCIAL_ICON.getAttribute('data-network');

                    this.popup(network, href);
                });
            }
        }
    }

    popup(network, href) {
        let options = 'menubar=no,toolbar=no,resizable=yes,scrollbars=yes,';
        window.open(href, '', options + 'height=' + this.NETWORKS[network].height + ',width=' + this.NETWORKS[network].width);
    };
}